import { queryStringFromObject } from '../../core/util/string';
import { apiGetJson } from '../../core/dapi/index';
import { DAPI_HOST } from '../../config';

export async function getLocationGeneralConfig<T>(
  config: string,
  locationId: string,
  inheritFromGroup = true
): Promise<T | undefined> {
  const qs = queryStringFromObject({
    config_names: config,
    location_id: locationId,
    inherit_from_group: inheritFromGroup,
  });
  const data = await apiGetJson<{ values: Record<string, any> }>(`${DAPI_HOST}/v1/config/?${qs}`);
  return data.data.values[config] ?? undefined;
}
